import api from 'shared/api';

export const revokeFeatureDevice = (featureID, deviceID) => {
  const url = `/api/v1/license-product-features/${featureID}/release_device/`;
  return api.post(url, { device: deviceID });
};
